/* ==========================================================================
   Monumental Theme - Global JavaScript
   ========================================================================== */

(function () {
  'use strict';

  // ── AJAX Add to Cart ────────────────────────────────────────────────────────
  // Intercepts product form submissions, uses the AJAX API, then dispatches
  // a 'cart:added' event so the cart drawer opens automatically.

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('#product-form');
    if (!form) return;

    e.preventDefault();

    const submitBtn = form.querySelector('[data-add-to-cart]');
    if (!submitBtn || submitBtn.disabled) return;

    const originalText = submitBtn.textContent.trim();
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw d; });
        return res.json();
      })
      .then(function (item) {
        submitBtn.textContent = 'Added!';
        updateHeaderCartCount();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item } }));
        setTimeout(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }, 2000);
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        if (err && err.description) {
          alert(err.description);
        }
      });
  });

  // ── Update header cart count badge ─────────────────────────────────────────
  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const count = cart.item_count;
        const cartLink = document.querySelector('.header-cart');
        let countEl = document.querySelector('[data-cart-count]');

        if (count > 0) {
          if (countEl) {
            countEl.textContent = count;
          } else if (cartLink) {
            countEl = document.createElement('span');
            countEl.className = 'header-cart-count';
            countEl.setAttribute('data-cart-count', '');
            countEl.textContent = count;
            cartLink.appendChild(countEl);
          }
        } else if (countEl) {
          countEl.remove();
        }
      });
  }

})();
